import React from 'react';
import useSeoForPage from '../hooks/useSeoForPage';

export default function LegalPage() {
  useSeoForPage('/impressum');
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="text-3xl font-semibold text-slate-900 mb-6" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
        Impressum
      </h1>

      <div className="space-y-4 text-slate-600 leading-relaxed text-[15px] mb-10">
        <p>
          <strong>Philip Grassegger</strong>
          <br />
          Graulinger Str. 13
          <br />
          29556 Suderburg
          <br />
          Deutschland
        </p>
        <p>
          <strong>E-Mail:</strong> kontakt@domain-preischeck.de
        </p>
        <p>
          Inhaltlich Verantwortlicher gemäß § 10 Absatz 3 MDStV: Philip Grassegger (Anschrift wie oben)
        </p>
        <p>
          <strong>Haftungshinweis:</strong> Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung
          für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber
          verantwortlich.
        </p>
      </div>

      <h2 className="text-xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
        Datenschutzerklärung
      </h2>

      <div className="space-y-4 text-slate-600 leading-relaxed text-[15px]">
        <p>
          <strong>1. Erhebung und Verarbeitung von http-Protokolldaten</strong>
          <br />
          Bei Besuch unserer Website und bei jedem Abruf einer Datei sammelt unser Webserver über diese Vorgänge
          Protokollinformationen (z. B. Browsertyp, Datum und Uhrzeit des Abrufs). Dies sind keine
          personenbezogenen Daten. Es ist uns nicht möglich, die erfassten Daten einer bestimmten natürlichen Person
          zuzuordnen. Sämtliche dieser Angaben werden von uns ausschließlich zu statistischen Zwecken ausgewertet.
          Eine Weitergabe an Dritte erfolgt nicht.
        </p>
        <p>
          <strong>2. Verwendung personenbezogener Daten</strong>
          <br />
          Personenbezogene Daten werden von uns nur dann und nur in dem Umfang erhoben, wie Sie sie uns mit Ihrer
          Kenntnis selbst zur Verfügung stellen. Eine Nutzung dieser personenbezogenen Daten für Zwecke der
          Werbung/Marktforschung sowie zur Gestaltung unserer Dienste erfolgt nur, wenn Sie uns ausdrücklich hierzu
          Ihre Einwilligung erteilt haben. Sie haben jederzeit ein Widerrufsrecht hinsichtlich einer erteilten
          Einwilligung. Eine Weitergabe der Daten an Dritte erfolgt ohne Ihre Einwilligung nur dann, wenn wir hierzu
          gesetzlich verpflichtet sind.
        </p>
        <p>
          <strong>3. Cookies</strong>
          <br />
          Ob Cookies gesammelt werden können, bestimmen Sie selbst, indem Sie Ihren Browser so einstellen, dass Sie
          vor dem Speichern eines Cookies informiert werden und eine Speicherung erst erfolgt, wenn Sie dies
          ausdrücklich akzeptieren. Wir verwenden Cookies nur zu dem Zweck, Informationen über die Nutzung unseres
          Webangebotes zu erhalten sowie zu statistischen Zwecken. Eine Zusammenführung mit etwaigen von Ihnen zur
          Verfügung gestellten personenbezogenen Daten erfolgt nicht.
        </p>
        <p>
          <strong>4. Auskunftsrecht</strong>
          <br />
          Sie haben das Recht, jederzeit Auskunft über die zu Ihrer Person gespeicherten Daten zu erhalten,
          einschließlich Herkunft und Empfänger Ihrer Daten sowie den Zweck der Datenverarbeitung. Ihre Anfrage
          richten Sie bitte schriftlich oder per E-Mail an unsere oben genannte Adresse.
        </p>
      </div>
    </div>
  );
}
